'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from '@radix-ui/react-icons';
import * as React from 'react';
import { cn } from '../../../lib/utils';
const Checkbox = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx(CheckboxPrimitive.Root, {
        ref: ref,
        className: cn('peer h-4 w-4 shrink-0 rounded-sm border border-primary shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground', className),
        ...props,
        children: /*#__PURE__*/ _jsx(CheckboxPrimitive.Indicator, {
            className: cn('flex items-center justify-center text-current'),
            children: /*#__PURE__*/ _jsx(CheckIcon, {
                className: "h-4 w-4"
            })
        })
    }));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
export { Checkbox };
